export default __webpack_public_path__ + "static/media/july2023-1.49341b4f.jpg";